export default "__VITE_ASSET__b89eb0d7__"